import React, {useContext, useEffect, useState} from "react";
// @ts-ignore
import {APIContext} from "../Globals.tsx";
import {CourseTypeDTO} from "../model/CourseTypeDTO";
import SelectDateWeex from "../elements/SelectDateWeex";
import SelectWeex from "../elements/SelectWeex";
import Windower from "./Windower"

export default function BoxTV(){
  const [programms, setProgramms] = useState([[]])
  const [selectedCourseType, setSelectedCourseType] = useState<CourseTypeDTO>(null)
  const [courseTypes, setCourseTypes] = useState<CourseTypeDTO[]>([])
  const [date, setDate] = useState(new Date())
  const {fetchPrograms, fetchCourseTypes} = useContext(APIContext)

  async function fetch(){
    return await fetchPrograms(date.toLocaleDateString('de-DE'), date.toLocaleDateString('de-DE'), selectedCourseType.short, false)
  }

  useEffect(() => {
    fetchCourseTypes().then((res) => {
      const courseTypesTmp = res?.types?.map(a => {
        return ({
          value: a.name, label: a.name, ...a
        });
      });
      setSelectedCourseType(courseTypesTmp ? courseTypesTmp[0] : null);
      setCourseTypes(courseTypesTmp);
    });
  }, [])

  useEffect(() => {
    if(selectedCourseType) fetch().then((week) => {
      setProgramms(week.days)
    })
  }, [selectedCourseType, date]);

  return (<div>
    <div style={{display: "flex", flexDirection: "row"}}>
      <button className={"primarybutton"} onClick={() => window.location.replace("/")}>Home</button>
      <SelectWeex
        isSearchable={false}
        options={courseTypes ?? []}
        value={selectedCourseType}
        onChange={(e) => setSelectedCourseType(e)}
        placeholder={"Kurs wählen"}
        style={{
          width: "200px", marginLeft: "auto", marginRight: "auto", marginTop: "0px", marginBottom: "10px", zIndex: 20,
        }}
      />
      <SelectDateWeex onChange={(e) => setDate(new Date(e))} value={date}
                      style={{
                        width: "auto"
                      }}/>

    </div>
    <Windower elements={programms[0] ?? []}/>
  </div>)
}